/**
 * UnavailableIcon/index.js
 * desc: unavailable / cancel icon
 * note: accessible icon-button (button + tooltip) by default; read-only renders a static glyph
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const UnavailableIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="unavailable icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.unavailable.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.0629 17.4191C13.7756 18.3358 12.2008 18.875 10.5 18.875C6.15076 18.875 2.625 15.3492 2.625 11C2.625 9.29922 3.16416 7.72437 4.08089 6.43705L15.0629 17.4191V17.4191ZM16.9191 15.563C17.8358 14.2756 18.375 12.7008 18.375 11C18.375 6.65076 14.8492 3.125 10.5 3.125C8.79922 3.125 7.22437 3.66416 5.93705 4.58089L16.9191 15.563V15.563ZM10.5 21.5C16.299 21.5 21 16.799 21 11C21 5.20101 16.299 0.5 10.5 0.5C4.70101 0.5 0 5.20101 0 11C0 16.799 4.70101 21.5 10.5 21.5V21.5Z"/>
        </svg>
    </IconButton>
);


export default UnavailableIcon;
